// extracted by mini-css-extract-plugin
export var backdropBlur = "_lq-0";
export var contentCard = "_lq-5";
export var frame = "_lq-2";
export var image = "_lq-4";
export var imagePane = "_lq-3";
export var modal = "_lq-1";